import React from 'react';
import { Switch, Redirect } from 'react-router-dom';

import { RouteWithLayout } from './components';
import PublicRoute from './route/publicRoute';
import PrivateRoute from './route/privateRoute';
import { Main as MainLayout, Minimal as MinimalLayout } from './layouts';

import {
    Dashboard as DashboardView,
    UserList as UserListView,
    Typography as TypographyView,
    Icons as IconsView,
    Account as AccountView,
    Settings as SettingsView,
    SignUp as SignUpView,
    SignIn as SignInView,
    NotFound as NotFoundView,
    InventoryList as InventoryListView,
    NewInventory as NewInventoryView,
    ViewInventory as ViewInventoryView
} from './views';

const Routes = () => {
    return ( 
    <Switch>
        <PublicRoute restricted = { true }
        component = { SignInView }
        exact layout = { MinimalLayout }
        path = "/sign-in" />
        
        <Redirect exact from = "/"
        to = "/sign-in" />

        <PrivateRoute component = { DashboardView }
        exact layout = { MainLayout }
        path = "/dashboard" />

        <PrivateRoute component = { UserListView }
        exact layout = { MainLayout }
        path = "/request" />

        <PrivateRoute component = { InventoryListView }
        exact layout = { MainLayout }
        path = "/inventory" />

        <PrivateRoute component = { NewInventoryView }
        exact layout = { MainLayout }
        path = "/inventory/new" />

        <PrivateRoute component = { ViewInventoryView }
        exact layout = { MainLayout }
        path = "/inventory/view" />

        <PrivateRoute component = { TypographyView }
        exact layout = { MainLayout }
        path = "/typography" />

        <PrivateRoute component = { IconsView }
        exact layout = { MainLayout }
        path = "/icons" />

        <PrivateRoute component = { AccountView }
        exact layout = { MainLayout }
        path = "/report" />
        <PrivateRoute component = { SettingsView }
        exact layout = { MainLayout }
        path = "/settings" />
        <PrivateRoute component = { SignUpView }
        exact layout = { MinimalLayout }
        path = "/sign-up" />

        <RouteWithLayout component = { NotFoundView }
        exact layout = { MinimalLayout }
        path = "/not-found" />
        <Redirect to = "/not-found" />
    </Switch>
    );
};

export default Routes;